import styled from 'styled-components';
import { iconButtonBackgroundHover } from 'styles/theme';

export const TitleContainer = styled.span`
    border-bottom: 1px solid ${iconButtonBackgroundHover};
`;

export function getKCFAcademyUrl(): string {
    return `https://academy.kcftech.com/learn`;
}
